import { useFeatureFlags } from 'common/hooks';
import useUser from 'common/hooks/useUser';

const FEATURE_FLAG_NAME = 'Skip Venue Fetches for Ent/Brand Owners';

type FeatureFlagState = {
  isLoading: boolean;
  isEnabled: boolean;
};

const useBypassVenueFetchForEnterpriseUsersFeatureFlag = (): FeatureFlagState => {
  const { isEmployee, user } = useUser();
  const { data: featureFlags, isLoading } = useFeatureFlags([FEATURE_FLAG_NAME], {
    user_id: user?.id || '',
    is_employee: isEmployee,
  });
  const isEnabled = featureFlags?.[FEATURE_FLAG_NAME] === 'on';

  return { isLoading, isEnabled };
};

export default useBypassVenueFetchForEnterpriseUsersFeatureFlag;
